import { memo } from 'react';
import { useSwipeable } from 'react-swipeable';
import { useLocaleStore } from '@/store';
import { useThemeToken } from '@/hooks';
import { useTranslation } from 'react-i18next';

import './styles.css';

export interface WeekChangerProps {
  currentDot: number;
  weekDates: string[];
  onPressLeft: () => void;
  onPressRight: () => void;
  onPressDot: (index: number) => void;
}

export const WeekChanger = memo((props: WeekChangerProps) => {

  const [t] = useTranslation();
  const isRTL = useLocaleStore(state => state.dir) === 'rtl';
  const { colorPrimary } = useThemeToken();

  const swipeable = useSwipeable({
    onSwiping: (e) => {
      if (e.first) {
        if (e.dir === 'Left') props.onPressLeft();
        else if (e.dir === 'Right') props.onPressRight();
      }
    },
  });

  return (
    <div
      style={{ backgroundColor: colorPrimary }}
      className="week-changer-container rounded-none lg:rounded-lg !mt-auto lg:!mt-0 !mb-0 lg:!mb-auto"
      {...swipeable}
    >
      <button
        type="button"
        onClick={props.onPressRight}
        className="week-changer-buttons"
      >
        <span className={isRTL ? 'flaticon-right-chevron' : 'flaticon-left-chevron'} />
      </button>
      <span className="text-sm text-white font-medium">
      {t('common:labels.page')} {props.currentDot + 1} {t('common:labels.of')} {props.weekDates.length}
      </span>
      <button
        className="week-changer-buttons"
        type="button"
        onClick={props.onPressLeft}
      >
        <span className={isRTL ? 'flaticon-left-chevron' : 'flaticon-right-chevron'} />
      </button>
    </div>
  );
});

export default WeekChanger;
